import { Suspense, lazy, useEffect, useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import {
    PlusButton,
    ActionButton,
    ToggleSwitch,
    checkImage,
} from "../../../helper/ImageFormat";
import Breadcrumb from "../../../helper/Breadcrumb";
import Spinner from "../../../Components/spinner";
import {
    handleDragEnd,
    toggleStatus,
    deleteItem,
} from "../../../utils/apiUtils";
import { fetchAllData } from "../../../helper/ProductAttributeHandling";
import { MenuImageModal } from "../../../Model/Model";
import { getNextPosition } from "../../../helper/nextPosition";
import { useLocation } from "react-router-dom";
const DeleteModal = lazy(() => import("../../../Components/DeleteModel"));

const MenuImage = () => {
    const location = useLocation();
    const parentId = location.state?.id;
    const size=location.state?.size
    const [loading, setLoading] = useState(false);
    const [data, setdata] = useState([]);
    const [editingId, setEditingId] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [deleteItemId, setDeleteItemId] = useState({});
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [updatedata, setupdatedata] = useState(null);
    const [position, setPosition] = useState(0)
    const fetchData = async () => {
        await fetchAllData(`menu-image-pagination?menu_id=${parentId}`, setdata, null, setLoading);
    };

    useEffect(() => {
        fetchData();
    }, []);



    const toggleModal = () => {
        const position = getNextPosition(data)
        setPosition(position)
        setModalOpen(!modalOpen);
        setEditingId(false);
        setupdatedata({ menu_id: parentId });
    };


    const confirmDelete = async () => {
        setIsDeleting(true);
        try {
            const res = await deleteItem("menu-image", deleteItemId?.id, fetchData, [deleteItemId.image]);
            setDeleteItemId({});
            setDeleteModalOpen(false);
            return res;
        } catch (error) {
            return error;
        } finally {
            setIsDeleting(false);
        }
    };

    const handleStatusToggle = async (item) => {
        const updated = await toggleStatus("menu-image-status", item.id, item.isActive);
        if (updated) {
            setdata((prev) =>
                prev.map((s) =>
                    s.id === item.id ? { ...s, isActive: updated.isActive } : s
                )
            );
        }
    };



    const handleDelete = async (data) => {
        setDeleteItemId(data);
        setDeleteModalOpen(true);
    };

    const handleEditClick = (data) => {
        setEditingId(data.id);
        const { createdAt, updatedAt, ...otherData } = data;
        setupdatedata(otherData);
        setModalOpen(true);
    };
    const breadcrumbData = [
        { label: "Home", path: "/" },
        { label: "Menu", path: "/menu" },
        { label: "Menu Image", path: "/menu-image" },
    ];

    return (
        <div className="content-wrapper">
            <div className="page-header mt-5">
                <h3 className="custom-page-title">Menu Image</h3>
                <Breadcrumb items={breadcrumbData} />
            </div>
            <div
                className="d-flex justify-content-end bg-white p-2 mt-n2"
                style={{ gap: "10px" }}
            >
                <PlusButton handleAdd={toggleModal} module={"Sizes"} />
            </div>

            <div className="row mt-2">
                <div className="col-md-12 grid-margin stretch-card">
                    <div className="card">
                        <div className="card-body">
                            <DragDropContext
                                onDragEnd={(result) =>
                                    handleDragEnd({
                                        result,
                                        data: data,
                                        setData: setdata,
                                        apiEndpoint: "/menu-image-position",
                                    })
                                }
                            >
                                <Droppable droppableId="sizes">
                                    {(provided) => (
                                        <div
                                            {...provided.droppableProps}
                                            ref={provided.innerRef}
                                            className="table-responsive"
                                        >
                                            <table className="custom-table table table-striped">
                                                <thead>
                                                    <tr style={{ marginTop: "10px", border: "2px solid #fff" }}>
                                                        <th>#</th>
                                                        <th>Image</th>
                                                        <th>Active</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {loading ? (
                                                        <tr>
                                                            <td colSpan="12" className="text-center">
                                                                <Spinner />
                                                            </td>
                                                        </tr>
                                                    ) : data.length > 0 ? (
                                                        data.map((item, index) => (
                                                            <Draggable
                                                                key={item.id}
                                                                draggableId={item.id.toString()}
                                                                index={index}
                                                            >
                                                                {(provided) => (
                                                                    <tr
                                                                        ref={provided.innerRef}
                                                                        {...provided.draggableProps}
                                                                        {...provided.dragHandleProps}>
                                                                        <td>{item.position}</td>
                                                                        <td>{checkImage(item.image)}</td>
                                                                        <td>
                                                                            <Suspense fallback={<span>...</span>}>
                                                                                <ToggleSwitch
                                                                                    data={item}
                                                                                    name="isActive"
                                                                                    checked={item.isActive}
                                                                                    handleStatusToggle={handleStatusToggle}
                                                                                    module={"Sizes"}
                                                                                />
                                                                            </Suspense>
                                                                        </td>
                                                                        <td className="text-left col-4">
                                                                            <Suspense fallback={<span>...</span>}>
                                                                                <ActionButton
                                                                                    data={item}
                                                                                    module={"Sizes"}
                                                                                    handleEditClick={handleEditClick}
                                                                                    handleDelete={handleDelete}
                                                                                />
                                                                            </Suspense>
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </Draggable>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="5" className="text-center">
                                                                <h5>No data found.</h5>
                                                            </td>
                                                        </tr>
                                                    )}
                                                    {provided.placeholder}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </Droppable>
                            </DragDropContext>
                        </div>
                    </div>
                </div>
            </div>


            <Suspense fallback={<div>Loading...</div>}>
                {modalOpen && (
                    <MenuImageModal
                        modalOpen={modalOpen}
                        toggleModal={toggleModal}
                        editingId={editingId}
                        setEditingId={setEditingId}
                        setupdatedata={setupdatedata}
                        updatedata={updatedata}
                        position={position}
                        fetchData={fetchData}
                        size={size}
                    />
                )}
            </Suspense>

            <Suspense fallback={null}>
                {deleteModalOpen && (
                    <DeleteModal
                        deleteModalOpen={deleteModalOpen}
                        setDeleteModalOpen={() => setDeleteModalOpen(false)}
                        onConfirm={confirmDelete}
                        itemName="Menu Image"
                        isDeleting={isDeleting}
                    />
                )}
            </Suspense>
        </div>
    );
};

export default MenuImage;
